/* Exposure Club drawer intro: hyperspace jump (option A).
   Stars drift → stretch into lines while the logo flies in from the vanishing point → cream flash → calm starfield, logo full size.
   Runs on the canvas inside .club-drawer__intro whenever the drawer opens; stops
   when the intro finishes (tap to skip, timer or close). ~2.6 s; the drawer's
   data-intro-dwell sets when the body fades in. Reduced motion: no animation,
   the drawer's own CSS fade handles it. */
(function () {
  const CREAM = '#fcefdd';
  const INK = '#0f131c';
  const clamp = (v, a, b) => Math.max(a, Math.min(b, v));
  function curve(pts, t) {
    if (t <= pts[0][0]) return pts[0][1];
    for (let i = 1; i < pts.length; i++) {
      if (t <= pts[i][0]) {
        const [t0, v0] = pts[i - 1], [t1, v1] = pts[i];
        return v0 + (v1 - v0) * ((t - t0) / (t1 - t0));
      }
    }
    return pts[pts.length - 1][1];
  }
  const speed = (t) => curve([[0, 0.12], [0.5, 0.12], [1.4, 4.2], [1.45, 4.2], [1.5, 0.08], [2.6, 0.06]], t);
  const streak = (t) => curve([[0, 0], [0.55, 0], [1.4, 1], [1.45, 1], [1.5, 0]], t);
  const tint = (t) => curve([[0, 0], [0.9, 0], [1.4, 0.16], [1.45, 0]], t);
  const flash = (t) => curve([[1.38, 0], [1.45, 1], [1.75, 0]], t);
  // Logo flies in from the vanishing point through the whole jump (option C's finish), arriving full size on the flash.
  const logoScale = (t) => curve([[0.3, 0.05], [1.45, 1]], t);
  const logoAlpha = (t) => curve([[0.3, 0], [0.8, 1]], t);
  const tagAlpha = (t) => curve([[1.75, 0], [2.0, 1]], t);
  const lineAlpha = (t) => curve([[1.95, 0], [2.2, 1]], t);

  function makeStars(n) {
    const s = [];
    for (let i = 0; i < n; i++) s.push({ x: Math.random() * 2 - 1, y: Math.random() * 2 - 1, z: Math.random() * 0.95 + 0.05, pz: 0 });
    return s;
  }

  function start(drawer) {
    const intro = drawer.querySelector('.club-drawer__intro');
    const cv = intro && intro.querySelector('canvas.ea-warp');
    if (!cv) return;
    stop(drawer);
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      intro.classList.add('ea-warp--still');
      return;
    }
    const ctx = cv.getContext('2d');
    const flashEl = intro.querySelector('.ea-warp__flash');
    const tintEl = intro.querySelector('.ea-warp__tint');
    const logo = intro.querySelector('.ea-warp__logo');
    const tag = intro.querySelector('.ea-warp__tag');
    const line = intro.querySelector('.ea-warp__line');
    const dpr = Math.min(window.devicePixelRatio || 1, 2);
    const W = (cv.width = Math.max(1, intro.clientWidth) * dpr);
    const H = (cv.height = Math.max(1, intro.clientHeight) * dpr);
    const cx = W / 2, cy = H * 0.46, f = Math.min(W, H) * 0.9;
    let stars = makeStars(260);
    let reset = false;
    const t0 = performance.now();
    let last = t0;

    function frame(now) {
      const t = (now - t0) / 1000;
      const dt = Math.min(0.05, (now - last) / 1000);
      last = now;
      if (!reset && t >= 1.45) { reset = true; stars = makeStars(260); }
      const sp = speed(t), st = streak(t);
      ctx.fillStyle = INK; ctx.fillRect(0, 0, W, H);
      ctx.lineCap = 'round';
      for (const s of stars) {
        s.pz = s.z; s.z -= sp * dt * 0.6;
        if (s.z <= 0.02) { s.x = Math.random() * 2 - 1; s.y = Math.random() * 2 - 1; s.z = 1; s.pz = 1; }
        const sx = cx + (s.x / s.z) * f, sy = cy + (s.y / s.z) * f;
        const tail = Math.max(s.pz, s.z + st * 0.18 * (0.3 + sp * 0.25));
        const px = cx + (s.x / tail) * f, py = cy + (s.y / tail) * f;
        const size = (1 - s.z) * 2.2 * dpr + 0.4;
        ctx.globalAlpha = clamp(0.3 + (1 - s.z), 0, 1);
        if (st > 0.02) {
          ctx.strokeStyle = CREAM; ctx.lineWidth = size;
          ctx.beginPath(); ctx.moveTo(px, py); ctx.lineTo(sx, sy); ctx.stroke();
        } else {
          ctx.fillStyle = CREAM;
          ctx.beginPath(); ctx.arc(sx, sy, size / 2, 0, Math.PI * 2); ctx.fill();
        }
      }
      ctx.globalAlpha = 1;
      if (tintEl) tintEl.style.opacity = tint(t);
      if (flashEl) flashEl.style.opacity = flash(t);
      if (logo) {
        logo.style.transform = 'translate(-50%,-50%) scale(' + logoScale(t).toFixed(3) + ')';
        logo.style.opacity = logoAlpha(t);
      }
      if (tag) { tag.style.opacity = tagAlpha(t); tag.style.transform = 'translateY(' + ((1 - tagAlpha(t)) * 10) + 'px)'; }
      if (line) line.style.opacity = lineAlpha(t);
      if (t < 4) drawer._eaWarpRaf = requestAnimationFrame(frame);
    }
    drawer._eaWarpRaf = requestAnimationFrame(frame);
  }

  function stop(drawer) {
    if (drawer._eaWarpRaf) cancelAnimationFrame(drawer._eaWarpRaf);
    drawer._eaWarpRaf = null;
  }

  document.addEventListener('club-drawer:open', (e) => {
    const drawer = document.querySelector('club-drawer');
    if (drawer) start(drawer);
  });
  document.addEventListener('club-drawer:intro-done', () => {
    const drawer = document.querySelector('club-drawer');
    if (drawer) stop(drawer);
  });
  document.addEventListener('club-drawer:close', () => {
    const drawer = document.querySelector('club-drawer');
    if (drawer) stop(drawer);
  });
  window.eaClubWarp = { start, stop };
})();
